import { useEffect } from 'react';
import { useModel } from 'umi';

import { pushIdentifyUserLogin } from '@/tracking/gtm/user';
import { identifyUserLogin, trackIdentifyUserLogin } from '@/tracking/segment/user';
import userInfoManager from '@/utils/userInfoManager';

const useInitUser = () => {
  const { initialState } = useModel('@@initialState');

  useEffect(() => {
    if (initialState?.currentUser) {
      const { id, email, name } = initialState?.currentUser;
      userInfoManager.initUser({ userId: id, name, email });
      pushIdentifyUserLogin();
      identifyUserLogin({
        userId: id,
        email,
        name,
      });
      trackIdentifyUserLogin();
    }
  }, [initialState?.currentUser?.id]);
};

export default useInitUser;
